import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});

export default function SummaryHistoryTable({ resultSet }) {
    const classes = useStyles();

    return (
        <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Data</TableCell>
                        <TableCell>Estacionamento</TableCell>
                        <TableCell>Descrição</TableCell>
                        <TableCell>Placa</TableCell>
                        <TableCell>Valor</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {resultSet.map((history, index) => (
                        <TableRow key={index}>
                            <TableCell component="th" scope="row">{history.arrival}</TableCell>
                            <TableCell>{history.establishment_name}</TableCell>
                            <TableCell>{history.vehicle_name}</TableCell>
                            <TableCell>{history.plaque}</TableCell>
                            <TableCell>R${history.value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}